import { lighten } from "polished"
import styled, { css } from "styled-components"

export const Grid = styled.div`
  display: grid;
  grid-template-columns: repeat(5, minmax(0, 1fr));
  grid-gap: 0.25rem;
  margin-top: 0.25rem;
`

export const Item = styled.button<{ isActive?: boolean }>`
  background: ${(p) => p.theme.colors.card.default};
  border: 2px solid ${(p) => p.theme.colors.card.default};
  aspect-ratio: 1/1;
  outline: none;
  border: none;
  cursor: pointer;
  display: flex;
  justify-content: center;
  transition: background 0.1s ease-in-out;
  align-items: center;

  ${(p) =>
    p.isActive &&
    css`
      border: 2px solid ${p.theme.colors.card.active};
    `}

  &:hover {
    background: ${(p) => lighten(0.05, p.theme.colors.card.active)};
  }
`

export const Image = styled.img`
  max-width: 100%;
`
